import type { CityConfig } from "../city-template/types";

export const baltimoreConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Baltimore",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "baltimore",
  route: "/cities/baltimore",
  title: "Emergency Passport Baltimore, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Baltimore, MD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Baltimore medical professionals, Johns Hopkins travelers, BWI passengers, and Maryland families.",
  h1: "Emergency & Expedited Passport Services in Baltimore, MD",
  heroSubtitle: "BWI flight to London in two weeks? Medical conference in Geneva? Family cruise from the Inner Harbor? We help Baltimore residents — from Johns Hopkins physicians to Fells Point families to Towson professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Baltimore%20Maryland%20Inner%20Harbor%20skyline%20at%20golden%20hour%20with%20historic%20waterfront%20buildings%2C%20modern%20glass%20skyscrapers%2C%20Federal%20Hill%20park%2C%20and%20the%20Chesapeake%20Bay%20in%20the%20distance%2C%20warm%20amber%20lighting%20reflecting%20on%20the%20water%2C%20dramatic%20clouds%2C%20professional%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20clean%20architectural%20details&width=1800&height=700&seq=baltimore-hero-001&orientation=landscape",
  heroImageAlt: "Aerial view of Baltimore Inner Harbor skyline at golden hour with waterfront buildings and Chesapeake Bay",
  geoPosition: "39.2904;-76.6122",
  geoPlacename: "Baltimore, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 45–55 minutes from downtown Baltimore via I-95 S. Maryland has no passport agency of its own.",
  },
  nearbyCitiesZips: [
    { name: "Baltimore", zips: "21201–21252" },
    { name: "Towson", zips: "21204, 21252, 21286" },
    { name: "Catonsville", zips: "21228, 21229" },
    { name: "Columbia", zips: "21044, 21045, 21046" },
    { name: "Ellicott City", zips: "21041, 21042, 21043" },
    { name: "Glen Burnie", zips: "21060, 21061, 21062" },
    { name: "Dundalk", zips: "21222" },
    { name: "Essex", zips: "21221" },
    { name: "Parkville", zips: "21234" },
    { name: "Pikesville", zips: "21208" },
    { name: "Lutherville", zips: "21093" },
    { name: "Timonium", zips: "21093" },
    { name: "Rosedale", zips: "21237" },
    { name: "Middle River", zips: "21220" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour BWI Emergency Processing", desc: "Reserved courier access to the Washington DC Passport Agency — as fast as 24 hours for Baltimore travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "BWI Airport Expertise", desc: "Southwest hub with growing international routes to London, Cancun, Reykjavik, and the Caribbean. We know BWI airline timelines and last-minute boarding scenarios." },
    { icon: "ri-hospital-line", title: "Medical & Research Hub", desc: "Johns Hopkins, University of Maryland Medical Center, NIH-adjacent researchers — short-notice international conferences and global health deployments." },
    { icon: "ri-ship-line", title: "Cruise Port Ready", desc: "Baltimore Cruise Terminal at South Locust Point. Royal Caribbean and Carnival departures to the Bahamas, Bermuda, and Caribbean require valid passports." },
  ],
  internalLinks: [
    { name: "Fast passport services in Annapolis, MD", route: "/cities/annapolis" },
    { name: "Expedited passport in Silver Spring, MD", route: "/cities/silver-spring" },
    { name: "Quick passport services in Columbia, MD", route: "/cities/columbia" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeAddress: "600 19th St NW, 1st Floor, Washington, DC 20006",
  fpcOfficeNote: "Fast Passport Center serves Baltimore via secure registered courier with direct access to the Washington DC Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the 45–55 minute drive to downtown DC. Baltimore residents can ship from any UPS Store, FedEx Office, or post office location across the Baltimore metro area.",
  fpcOfficeDistance: "Serving Baltimore, Towson, Columbia, Catonsville, Ellicott City, and all Baltimore metro communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Baltimore and the greater Baltimore-Washington corridor. From the historic neighborhoods of Federal Hill, Fells Point, and Canton to the medical corridors of Johns Hopkins Hospital and the University of Maryland, from the northern suburbs of Towson and Pikesville to the planned community of Columbia — we serve all of Baltimore City, Baltimore County, Howard County, and Anne Arundel County. Our courier service eliminates the need to drive to downtown DC and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Baltimore and all Baltimore metro communities including Towson, Catonsville, Columbia, Ellicott City, Glen Burnie, Dundalk, Essex, Parkville, Pikesville, Lutherville, and Timonium. We also serve travelers departing from BWI Marshall Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Baltimore as simple as possible — with the efficiency and reliability medical professionals, university researchers, and Maryland families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Baltimore travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Baltimore travelers encounter unique passport issues — everything from BWI same-day bookings to cruise documentation requirements to medical conference timing. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Baltimore travelers — from Hopkins physicians to Inner Harbor families to Towson professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Baltimore, MD? Here are the most common ones we hear from Charm City travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  servicesIntro: "Whether you need a renewal before a BWI flight to London, an emergency passport for a medical conference in Geneva, or a first-time passport for a Maryland family cruise — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for medical conferences and family cruises", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 45–55 min to downtown DC", "Full day commitment — challenging for medical professionals"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "BWI flight to London in two days? Medical conference in Geneva this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Baltimore-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Baltimore residents renew fast — no agency visit required for most renewals. Perfect for Hopkins physicians, UM researchers, and Maryland professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Baltimore residents through every step — from Fells Point to Towson to Columbia — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your BWI international connection or research trip isn't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Maryland family cruise or vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Baltimore professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Baltimore medical researchers, global health workers, and business travelers who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Baltimore-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Perfect for Baltimore cruise passengers who want a backup ID ashore.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Baltimore MD", description: "Urgent passport processing for Baltimore Maryland travelers with immediate departure needs from BWI." },
    { name: "Expedited Passport Renewal Baltimore MD", description: "Fast passport renewal for Baltimore Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Baltimore MD", description: "New passport application services for Baltimore Maryland residents applying for their first passport." },
    { name: "Child Passport Baltimore MD", description: "Minor passport services for Baltimore Maryland families with children under 16." },
    { name: "Name Change Passport Baltimore MD", description: "Passport name correction after marriage, divorce, or legal name changes for Baltimore residents." },
    { name: "Second Passport Baltimore MD", description: "Second passport services for Baltimore medical researchers and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Dr. Michael R.",
      location: "Johns Hopkins, Baltimore",
      rating: 5,
      text: "Had a medical conference in Geneva in 5 days. Fast Passport Center reviewed every document, caught a photo issue, and delivered my renewed passport in 48 hours. Absolutely essential for busy medical professionals.",
      service: "Passport Renewal",
    },
    {
      name: "Lisa T.",
      location: "Fells Point, Baltimore",
      rating: 5,
      text: "Family cruise to the Caribbean with 8 days notice. Four passports processed in under a week. The agent coordinated everything — we just shipped the documents from the UPS Store on Boston Street.",
      service: "Family Passport Bundle",
    },
    {
      name: "James K.",
      location: "Towson, MD",
      rating: 5,
      text: "Business trip to Tokyo with 10 days notice. Fast Passport Center had my emergency passport ready in 3 days. No need to drive to DC — everything shipped overnight.",
      service: "Emergency Passport",
    },
    {
      name: "Angela M.",
      location: "Columbia, MD",
      rating: 5,
      text: "Lost my passport the week before my honeymoon in Italy. I was devastated. They walked me through the replacement process and had it in my hands in 48 hours. Truly saved our trip.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "baltimore-1",
      name: "Baltimore Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 E Fayette St",
      city: "Baltimore",
      state: "MD",
      zip: "21233",
      phone: "(410) 685-2635",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Baltimore, near the Inner Harbor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown acceptance facility. Appointments required — book 1–2 weeks in advance. Limited parking — plan for public transit or rideshare.",
      icon: "ri-mail-line",
    },
    {
      id: "baltimore-2",
      name: "Towson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 W Chesapeake Ave",
      city: "Towson",
      state: "MD",
      zip: "21204",
      phone: "(410) 296-2694",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Towson, approximately 8 miles north of Baltimore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Towson University students and northern Baltimore County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "baltimore-3",
      name: "Catonsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Ingleside Ave",
      city: "Catonsville",
      state: "MD",
      zip: "21228",
      phone: "(410) 788-4600",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Catonsville, approximately 10 miles west of downtown Baltimore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for western Baltimore County and UMBC area residents. Appointments fill quickly during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "baltimore-4",
      name: "Columbia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8805 Centre Park Dr",
      city: "Columbia",
      state: "MD",
      zip: "21045",
      phone: "(410) 730-2220",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Columbia Town Center, approximately 20 miles southwest of Baltimore",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Howard County residents. Good alternative for Ellicott City, Laurel, and Jessup families.",
      icon: "ri-mail-line",
    },
    {
      id: "baltimore-5",
      name: "Baltimore County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "11101 Gilroy Rd",
      city: "Hunt Valley",
      state: "MD",
      zip: "21031",
      phone: "(410) 887-2607",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Hunt Valley, approximately 15 miles north of downtown Baltimore",
      website: "https://www.baltimorecountymd.gov/",
      websiteLabel: "Baltimore County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via I-83.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 45–55 min to downtown DC Passport Agency", fpc: "Most Baltimore travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "BWI/Medical-Specific Guidance", agency: "Generic — no BWI, cruise port, or medical travel expertise", fpc: "Full BWI/cruise/Johns Hopkins/medical knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming the DC Agency Takes Walk-Ins",
      description: "The Washington DC Passport Agency requires appointments even for emergencies. Many Baltimore residents drive 45–55 minutes only to be turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cruise Document Confusion",
      description: "Baltimore Cruise Terminal passengers often assume a driver's license is sufficient for Caribbean cruises. All international cruises require a valid passport book — passport cards are not accepted for air travel if you need to fly back from a port.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Baltimore applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Maryland families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Baltimore travelers booking to Europe or Asia often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or Hopkins campus." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Baltimore clients ship from home or office — no need to drive to DC." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you don't have to battle I-95 traffic to the DC Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Baltimore?", a: "We offer Baltimore-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Does Baltimore have its own passport agency?", a: "No — neither Baltimore nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 45–55 minutes from downtown Baltimore via I-95. Fast Passport Center's courier service means Baltimore residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Towson or Columbia?", a: "Absolutely. Fast Passport Center serves the entire Baltimore metropolitan area including Towson, Columbia, Catonsville, Ellicott City, Glen Burnie, Dundalk, Essex, Parkville, and all of Baltimore County and Howard County. Our service works the same way everywhere — complete your application online, ship your documents, and we handle the rest." },
    { q: "Do I need a passport for a cruise from the Baltimore Cruise Terminal?", a: "Yes. All international cruises departing from Baltimore's South Locust Point terminal require a valid passport book. While some 'closed-loop' Caribbean cruises technically allow a birth certificate and government ID, having a passport book ensures you can fly home from any port if an emergency occurs." },
    { q: "How much does an expedited passport cost in Baltimore?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "What airports do Baltimore travelers use for international flights?", a: "Most Baltimore residents fly internationally through Baltimore-Washington International Airport (BWI), approximately 15 minutes south of downtown. Washington Dulles (IAD) and Reagan National (DCA) offer additional international connections. Philadelphia International (PHL) is also accessible for some travelers." },
    { q: "Can you help with passports for Johns Hopkins medical travel?", a: "Yes. We regularly assist Johns Hopkins physicians, researchers, and global health workers with expedited passports for international conferences, research deployments, and medical missions. We understand the short-notice nature of medical travel and prioritize these cases." },
    { q: "Where is the closest passport acceptance facility to downtown Baltimore?", a: "The Baltimore Main Post Office at 900 E Fayette St is the primary downtown acceptance facility. The Towson Post Office at 101 W Chesapeake Ave serves northern Baltimore County. The Catonsville Post Office at 1000 Ingleside Ave serves western suburbs. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Baltimore residents should plan ahead, especially for medical conferences and summer cruises." },
    { q: "Can I get a passport photo in Baltimore?", a: "Yes — many Baltimore CVS, Walgreens, UPS Stores, FedEx Office locations, and AAA offices offer passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression. We review your photos before submission." },
    { q: "Do you serve the DC suburbs from Baltimore?", a: "Yes. Fast Passport Center serves the entire Baltimore-Washington corridor including Silver Spring, Bethesda, Rockville, and Gaithersburg. Our courier service works identically throughout the region — no drive to downtown DC required." },
    { q: "What documents do Baltimore applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Baltimore-specific checklist." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Baltimore Residents",
    intro: "Baltimore's unique position as a Mid-Atlantic medical and research powerhouse — with BWI as its international gateway and DC's passport agency 45 minutes away — creates distinct passport timing challenges. Here's what Baltimore travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BWI — Baltimore-Washington International Airport",
        subtitle: "Southwest Airlines hub with growing international network",
        description: "BWI handles more than 27 million passengers annually with direct international flights to London, Cancun, Reykjavik, Punta Cana, and the Caribbean. Southwest's expanding international service from BWI means more Baltimore travelers are booking international flights than ever before — and many discover passport issues at the last minute. The airport's convenience (15 minutes from downtown) sometimes creates a false sense of travel readiness.",
        tip: "Southwest's international routes from BWI include Cancun, Montego Bay, Punta Cana, and Nassau. All require valid passports — even for 'quick Caribbean getaways.' Check your passport the moment you book, not when you pack.",
      },
      {
        icon: "ri-hospital-line",
        title: "Medical & Research Travel",
        subtitle: "Johns Hopkins, University of Maryland, NIH-adjacent institutions",
        description: "Baltimore is one of America's premier medical research hubs. Johns Hopkins alone sends thousands of physicians, researchers, and global health workers abroad each year — to Geneva for WHO meetings, to London for Lancet conferences, to sub-Saharan Africa for field research. Medical travel is often short-notice: a grant gets funded, a conference abstract gets accepted, or a global health deployment gets activated with 1–3 weeks of lead time.",
        tip: "Medical professionals should maintain a current passport at all times. Conference acceptances, grant deployments, and research opportunities often have 2–4 week windows that standard processing cannot meet. Our courier service is designed for exactly these scenarios.",
      },
      {
        icon: "ri-ship-line",
        title: "Baltimore Cruise Terminal & Seasonal Travel",
        subtitle: "Royal Caribbean and Carnival departures from South Locust Point",
        description: "The Baltimore Cruise Terminal at South Locust Point is a major Mid-Atlantic departure point for Caribbean, Bahamas, and Bermuda cruises. Peak season runs April through October, with families booking 6–12 weeks out. Many first-time cruisers — especially extended families — discover that children need passports and that processing timelines are tighter than expected for summer departures.",
        tip: "Cruise season creates a predictable passport demand surge March through June. Multi-generational family groups (4–8 passports) are common. Book your acceptance facility appointments 3–4 weeks before your cruise departure.",
      },
      {
        icon: "ri-building-2-line",
        title: "DC Agency Dependency & I-95 Commuter Factor",
        subtitle: "No Maryland passport agency — 45-55 min drive to DC",
        description: "Maryland is one of several states without its own passport agency, meaning Baltimore residents must drive to downtown DC for emergency agency service. The I-95/Baltimore-Washington Parkway corridor is notoriously congested during business hours, turning a 45-minute drive into 90+ minutes. For working professionals and medical staff who cannot take a full day off, the DC agency is not a realistic option.",
        tip: "The DC Passport Agency processes Maryland applications alongside DC and Virginia residents, creating high demand for limited appointments. Our courier service eliminates the I-95 drive entirely — ship documents from home and we handle the DC agency submission.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Baltimore & the Mid-Atlantic International Community",
      description: "Baltimore has large and growing international communities including Korean, Nigerian, Ethiopian, Salvadoran, and Indian populations with strong family ties abroad. Multi-generational passport needs — from newborn first-time applications to elder renewals — create steady year-round demand for expedited processing, especially around holidays and summer travel seasons.",
    },
  },
  destinations: {
    title: "Where Baltimore Travelers Go — And Why Passports Get Urgent",
    intro: "BWI's expanding international network and Baltimore's medical/research prominence mean Charm City travelers need passports for destinations spanning the globe. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Baltimore expedited requests are medical conference or research deployment-related" },
      { stat: "2–4 Weeks", label: "average lead time Baltimore medical travelers have from conference acceptance to departure" },
      { stat: "Mar–Jun", label: "peak season when cruise bookings, medical conferences, and summer travel plans collide" },
      { stat: "30 Hours", label: "shortest turnaround we have accommodated for a Hopkins physician departing to Geneva" },
    ],
    destinations: [
      { name: "Caribbean & Bahamas", context: "BWI nonstop flights to Cancun, Punta Cana, Montego Bay, Nassau. Cruise departures from Baltimore and nearby ports", urgency: "Cruise and resort bookings spike March through June for summer departures", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "BWI-London nonstop, medical conferences, academic partnerships, heritage travel for Irish-American community", urgency: "Medical conferences have fixed dates — acceptance notifications come 3–6 weeks before events", icon: "ri-map-pin-2-line" },
      { name: "Switzerland & France", context: "WHO Geneva meetings, Basel pharmaceutical conferences, medical device trade shows", urgency: "Global health deployments and pharma meetings booked 1–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Sub-Saharan Africa", context: "Hopkins global health deployments, USAID research, NGO medical missions to Nigeria, Ethiopia, Kenya", urgency: "Field research deployments often have 2–4 week activation windows", icon: "ri-map-pin-2-line" },
      { name: "Italy & Mediterranean", context: "Heritage travel, academic sabbaticals, honeymoons, Mediterranean cruises", urgency: "Summer bookings peak January through March; honeymoon timelines are fixed", icon: "ri-map-pin-2-line" },
      { name: "Iceland & Nordics", context: "BWI-Reykjavik nonstop via Icelandair, connecting to European medical conferences", urgency: "Icelandair connections create last-minute European gateway scenarios", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Maryland Service Areas",
    crossLinksDesc: "We serve travelers across the Old Line State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Annapolis", route: "/cities/annapolis" },
      { name: "Silver Spring", route: "/cities/silver-spring" },
      { name: "Columbia", route: "/cities/columbia" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Downtown Baltimore", address: "200 N Charles St, Baltimore, MD 21201", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Inner Harbor", address: "100 E Pratt St, Baltimore, MD 21202", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Towson", address: "1000 York Rd, Towson, MD 21204", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Columbia", address: "8860 Columbia 100 Pkwy, Columbia, MD 21045", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Baltimore City", address: "5425 Reisterstown Rd, Baltimore, MD 21215", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Baltimore City and northwest Baltimore County. REAL ID processing available.", featured: true },
    { name: "MVA — Glen Burnie", address: "6601 Ritchie Hwy, Glen Burnie, MD 21062", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Flagship MVA location for the Baltimore metro area. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "15–20 minutes from downtown Baltimore",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary international departure airport for Baltimore travelers. Direct flights to London, Cancun, Reykjavik, and the Caribbean. Southwest Airlines hub with extensive domestic connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "50–60 minutes from downtown Baltimore",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Secondary option for international connections via domestic hubs. Major business travel airport.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International (Washington DC)",
      distance: "60–70 minutes from downtown Baltimore",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for long-haul international flights to Europe and Asia. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office. Serving Baltimore City and all Maryland counties.",
      url: "https://health.maryland.gov/vsa/Pages/home.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.",
      url: "https://health.maryland.gov/vsa/Pages/home.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from the Baltimore City Circuit Court Clerk. Required for name change passport applications for Baltimore City marriages.",
      url: "https://www.baltimorecity.gov/government/circuitcourt",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Baltimore City Circuit Court. Required for name change passport corrections and legal documentation.",
      url: "https://www.baltimorecity.gov/government/circuitcourt",
    },
  ],
};